export const lv = {
    button: {
        basemap: "Mainīt pamatkarti",
        compass: "Atiestatīt kompasa orientāciju",
        location: "Atrast manu novietojumu",
        home: "Sākuma skats"
    }
};
export const eng = {
    button: {
        basemap: "Change basemap",
        compass: "Reset compass",
        location: "Get location",
        home: "Home"
    }
};
